import * as types from "./actiontypes"

const initialState = {
    officeData: null,
    isLoading: false,
    isError: false
}

export const Officereducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case types.GET_OFFICE_REQUEST:
            return {
                ...state,
                isLoading: true,
                isError: false
            }

        case types.GET_OFFICE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isError: false,
                officeData: payload
            }

        case types.GET_OFFICE_FAILURE:
            return {
                ...state,
                isLoading: false,
                isError: true,
                // massage: ""
            }

        case types.CREATE_OFFICE_REQUEST:
            return {
                ...state,
                isLoading: true,
                isError: false
            }

        case types.CREATE_OFFICE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isError: false,
                officeData: payload
            }

        case types.CREATE_OFFICE_FAILURE:
            return {
                ...state,
                isLoading: false,
                isError: true
            }

        default:
            return state
    }
}